import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {AnimUtils} from "../utils/AnimUtils";
import {gsap} from "gsap";
import {HOTB} from "../HOTB";

export class PreBigWinView extends PIXI.Container implements StageLayer {
    private _preBigWinSpine: PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "PreBigWinView";
        this.init();
    }

    public playPreBigWin(animName: string): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add([
            AnimUtils.playSpineAnimation({
                spineObj: this._preBigWinSpine,
                animation: animName,
            }),
            HOTB.gameOverlay.toggleTrimmedOverlay(true)
        ]);

        return tl;
    }

    public resetAnim(): void {
        AnimUtils.resetSpine(this._preBigWinSpine, false);
    }

    private init(): void {
        this.createPreBigWinAnim();
    }

    private createPreBigWinAnim(): void {
        this._preBigWinSpine = this.createSpine("bigWin_0");
        this.addChild(this._preBigWinSpine);
    }

    private createSpine(spinePath: string): PIXI.spine.Spine {
        return AnimUtils.createNewSpine({
            path: spinePath,
            name: spinePath,
            pos: new PIXI.Point(360, 395),
            initShow: false
        });
    }
}